var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import FAIcon from "../FAIcon/FAIcon";
import useConfirmation from "../../Hooks/useConfirmation";
import useService from "../../Hooks/useService";
import useErrorPopup from "../../Hooks/useErrorPopup";
/**
 * A secondary nav intended to be placed under the main navigation bar at the top of the page.
 */
const SecondaryNavButton = (_a) => {
    var { icon, iconType, label, active, title, isLoading: _propIsLoading, disabled, spin, confirmMessage, onClickWithLoader, onClick, type } = _a, otherProps = __rest(_a, ["icon", "iconType", "label", "active", "title", "isLoading", "disabled", "spin", "confirmMessage", "onClickWithLoader", "onClick", "type"]);
    const [confim, confirmModals] = useConfirmation();
    const [showError, popups] = useErrorPopup();
    const [clickState, clickWithLoader] = useService(onClickWithLoader
        ? (...args) => onClickWithLoader(...args).catch((err) => {
            showError(err);
            throw err;
        })
        : (...args) => Promise.resolve(onClick === null || onClick === void 0 ? void 0 : onClick(...args)));
    const isLoading = _propIsLoading || clickState.isLoading;
    return (_jsxs("div", { title: title, children: [_jsxs("button", Object.assign({ type: (type !== null && type !== void 0 ? type : "button") }, otherProps, { onClick: (...args) => __awaiter(void 0, void 0, void 0, function* () {
                    if (confirmMessage) {
                        const confirmed = yield confim(confirmMessage);
                        if (confirmed) {
                            clickWithLoader(...args);
                        }
                    }
                    else {
                        clickWithLoader(...args);
                    }
                }), className: "btn btn-link", disabled: isLoading || disabled, children: [_jsx(FAIcon, { icon: icon, spin: spin, type: iconType, isLoading: isLoading, className: "mr-2" }), _jsx("span", { className: "d-none d-lg-inline-block", children: label })] })), confirmModals, popups] }));
};
export const SecondaryNavLink = (_a) => {
    var { icon, iconType, label, active, title, spin, to, 
    // @ts-expect-error - TS2339 - Property 'disabled' does not exist on type 'Props & { to: string; }'.
    disabled } = _a, otherProps = __rest(_a, ["icon", "iconType", "label", "active", "title", "spin", "to", "disabled"]);
    return (_jsx("div", { title: title, children: _jsxs(Link, Object.assign({}, otherProps, { to: to, className: classNames("btn btn-link", { disabled }), children: [_jsx(FAIcon, { icon: icon, spin: spin, type: iconType, className: "mr-2" }), _jsx("span", { className: "d-none d-lg-inline-block", children: label })] })) }));
};
export const SecondaryNavExternalLink = (_a) => {
    var { icon, iconType, label, active, title, spin, href } = _a, otherProps = __rest(_a, ["icon", "iconType", "label", "active", "title", "spin", "href"]);
    return (_jsx("div", { title: title, children: _jsxs("a", Object.assign({}, otherProps, { href: href, className: "btn btn-link", children: [_jsx(FAIcon, { icon: icon, spin: spin, type: iconType, className: "mr-2" }), _jsx("span", { className: "d-none d-lg-inline-block", children: label })] })) }));
};
export default SecondaryNavButton;
